<template>
  <div :class="{ Redirect: true, 'Redirect--small': $mq === 'mobile' }">
    <div class="Text">{{ t('text') }}</div>

    <div class="Content">
      <div class="Quote">
        <img src="@/assets/quote-open.png" class="Asset-Before" />
        {{ t(`quote.${quote}`) }}
        <img src="@/assets/quote-close.png" class="Asset-After" />
      </div>
    </div>

    <div class="Author">{{ t(`quote.author_${quote}`) }}</div>
  </div>

</template>

<script>
import { db } from '@/services/firebase'
import userMixin from '@/mixins/user'
import { RESET_SHOP, SET_HIGHEST_PRODUCT_TYPE, CREATE_GIFT_DISCOUNT } from '@/store/modules/shop/types'
import { GET_COMMANDS, SET_COMMANDS, SEND_GIFT_EMAIL } from '@/store/modules/user/types'
import shopMixin from '@/mixins/shop'
import {SNACKBAR_MESSAGE} from "@/helpers/eventBus";

export default {
  name: 'ShopRedirect',
  mixins: [userMixin, shopMixin],
  computed: {
    quote() {
      const quotes = [1, 2, 3, 4, 5, 6]
      return quotes[Math.floor(Math.random() * quotes.length)]
    },
    checkout() {
      return this.$store.state.shop.checkout
    }
  },
  methods: {
    t(key, params) {
      return this.$t(`shop.redirect.${key}`, params)
    },
    shopSuccess(commands) {
      // Command have been persisted, reset the shop and update commands
      this.$store.dispatch(RESET_SHOP)

      this.$store.commit(SET_COMMANDS, commands)

      this.$gtm.trackEvent({
        event: 'done payflow', // Event type [default = 'interaction'] (Optional)
        category: 'Shop',
        action: 'passive',
        label: 'Shopping completed',
        value: {
          userId: this.userId,
          payflowCompleted: false
        },
        noninteraction: false // Optional
      });

      this.$router.push({ name: 'shop-success' })
    },
    getShopifyProductsBySku(sku) {
      return this.$store.state.shop.masterclasses.filter(masterclass => masterclass.variants[0].sku === sku)
        .sort((a, b) => Number(a.variants[0].price) - Number(b.variants[0].price))
    }
  },
  watch: {
    async checkout() {
      if (this.checkout && this.checkout.id) {
        
        // get highest type of product from the checkout
        let highestProductType = 0
        
        if (this.checkout.lineItems.length > 0) {
          // set the highest product type
          highestProductType = this.checkout.lineItems.map(item => {
            return parseInt(item.customAttributes[0].value)
          }).sort((a, b) => {
            return b - a
          }).shift()
        }
        this.$store.commit(SET_HIGHEST_PRODUCT_TYPE, highestProductType)

        // check if there is any gift
        const itemsAsGifts = this.checkout.lineItems.filter(item => {
          return item.customAttributes.find(att => 'key' in att && att.key == "gift" && att.value != null && att.value !== "{}")
        })
        itemsAsGifts.forEach(async item => {
          // get masterclass first offer by sku
          const masterclassesProducts = this.getShopifyProductsBySku(item.variant.sku)

          if (masterclassesProducts.length > 0) {
            const variant = masterclassesProducts[0].variants[0]
            const discountCode = await this.$store.dispatch(CREATE_GIFT_DISCOUNT, {variantId: atob(variant.id).split('gid://shopify/ProductVariant/')[1], title: variant.sku, price: variant.price})
            /**
             discountCode = {
               "id": 11324198879393,
              "price_rule_id": 946442993825,
              "code": "SKU-X",
              "usage_count": 0,
              "created_at": "2021-06-09T10:44:40-04:00",
              "updated_at": "2021-06-09T10:44:40-04:00"
            }
            */
            const userGiftField = JSON.parse(item.customAttributes[1].value)
            this.$store.dispatch(SEND_GIFT_EMAIL, { 
              sender: this.user.firstname ? this.user.firstname : "",
              email: this.user.email,
              mc: masterclassesProducts[0].title,
              name: userGiftField.firstname,
              discount: discountCode.code
            })
          } else {
            this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: 'Il y a eu un problème avec votre cadeau, merci de contacter le support.' })
          } 
        });

        const decodedToken = atob(this.checkout.id)
          .split('gid://shopify/Checkout/')[1]
          .split('?')[0]
        const commands = await this.$store.dispatch(GET_COMMANDS)
        if (commands.hasOwnProperty(decodedToken)) {
          this.shopSuccess(commands)
        }

        let email = this.userEmail ? this.userEmail : this.user.email
        db.collection('commands')
          .doc(email)
          .onSnapshot(doc => {
            const data = doc.data()

            if (data.commands && data.commands.hasOwnProperty(decodedToken)) {
              this.shopSuccess(data.commands)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Redirect {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 90px);

  .Text {
    font-size: 35px;
    margin-bottom: 50px;
  }

  .Quote {
    width: 70%;
    font-size: 40px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    position: relative;

    .Asset-Before {
      width: 20px;
      height: 20px;
      position: absolute;

      @media (max-width: 450px) {
        left: 15px;
        top: -5px;
      }
    }

    .Asset-After {
      width: 20px;
      height: 20px;
      position: absolute;
    }
  }
  .Author {
    margin-top: 30px;
    width: 70%;
    text-align: right;
    font-size: 20px;
    font-style: italic;
  }

  &--small {
    height: calc(100vh - 53px);

    .Text {
      font-size: 25px;
    }

    .Quote {
      font-size: 35px;
    }
  }
}


.bgPopupAddToCart {
  background-color: #00000055;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.inBgPopupAddToCart {
  background-color: white;
  padding: 20px;
  border-radius: 300px;
  width: 450px;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.poputBtAddToCart {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.outImgPopupAddToCart {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.imgPopupAddToCart {
  width: 80px;
  margin-bottom: 30px;
}

.titlePopupAddToCart {
  font-weight: 500;
  font-size: 22px;
  margin-bottom: 8px;
  width: 100%;
  text-align: center;
}

.textPopupAddToCart {
  font-size: 14px;
  margin-bottom: 40px;
  width: 100%;
  text-align: center;
}

.poputBtAddToCart > div , .poputBtAddToCart > a {
  // background-color: #D10A49;
  padding: 8px 0px;
  border-radius: 4px;
  color: #D10A49;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  margin: 0px 5px 30px 5px;
  width: 165px;
  text-align: center;
  border: 2px solid #D10A49
}

.poputBtAddToCart > div:hover , .poputBtAddToCart > a:hover {
  color: white;
  background-color: #D10A49;
}

@media screen and (max-width: 400px) {
  .imgPopupAddToCart {
    width: 50px;
    margin-bottom: 15px;
  }
  .inBgPopupAddToCart {
    width: 95vw;
    height: 95vw;
  }
  .poputBtAddToCart > div , .poputBtAddToCart > a {
    width: 110px;
    font-size: 12px;
  }
  .titlePopupAddToCart {
    font-size: 19px;
    margin-bottom: 6px;
    width: 100%;
  }

  .textPopupAddToCart {
    font-size: 12px;
    margin-bottom: 25px;
  }
}
</style>
